import { render, staticRenderFns } from "./DenunciaFormDatosGenerales.vue?vue&type=template&id=2955cbce&scoped=true"
import script from "./DenunciaFormDatosGenerales.vue?vue&type=script&lang=js"
export * from "./DenunciaFormDatosGenerales.vue?vue&type=script&lang=js"
import style0 from "./DenunciaFormDatosGenerales.vue?vue&type=style&index=0&id=2955cbce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2955cbce",
  null
  
)

export default component.exports